// src/UserFormPage.js

import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Layout,
  Avatar,
  Upload,
  Switch,
  Row,
  Col,
  Breadcrumb,
  Card,
  message,
} from "antd";
import { ArrowLeftOutlined, EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { ServiceUtils } from "../../../../Shared/Utils/ServiceUtils";
import BreadcrumbList from "../../../../Shared/Components/Breadcrumb/Breadcrumb";
import { alertService } from "../../../../Shared/Utils/ToasterUtils";
const { Option } = Select;
const { Header, Content } = Layout;





const AddEditReports = ({ ...props }) => {
  const [form] = Form.useForm();
  const [workspaces, setWorkspaces] = useState([]);
  const [reports, setReports] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [submittable, setSubmittable] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [reRendered, setReRendered] = useState(false);
  const navigate = useNavigate();
  const {id} = useParams();

  useEffect(() => {
    fetchWorkspaces();
    fetchDepartments();
    if (id) {
        setDisabled(true);
    } 
  }, []);


  useEffect(() => {
    const selectedSubDepartments = form.getFieldValue("subDepartments");
    if (selectedSubDepartments?.length > 0 && subDepartments?.length > 0 && reRendered) {
      let filteredSubDept = subDepartments
        .filter((dept) => selectedSubDepartments.includes(dept?.value))
        .map((val) => val.value);
        console.log(filteredSubDept,"filteredSubDept")
      if (filteredSubDept?.length) {
        form.setFieldsValue({
          subDepartments: filteredSubDept,
        });
      }
    }
  }, [subDepartments, reRendered]);

 useEffect(() => {
   if (id && departments?.length > 0) fetchFormDefaultData();
 }, [departments]);

  const fetchFormDefaultData = () => {
    const payload = {
      id: id
    };
    ServiceUtils.postRequest("getReportDetails", payload).then(
      (response) => {
        if (response.status === 200 && response?.data) {
            const deptIds = response?.data?.departments.map(Number);
            const subDeptIds = response?.data?.subDepartments.map(Number);
          form.setFieldsValue({
            workspaces: response?.data?.workspaces,
            reports: response?.data?.reports,
            departments: response?.data?.departments.map(Number),
            subDepartments: [],
          });

          if (deptIds?.length > 0) {
            ServiceUtils.postRequest("listSubDepartments", {
              departments: deptIds,
            }).then((res) => {
              if (res.status === 200 && res?.data.status) {
                const subDeptOptions = res?.data?.data;
                setSubDepartments(subDeptOptions);

                // set subDepartments that are part of the default data
                const selectedSubDept = subDeptOptions
                  .filter((dept) => subDeptIds.includes(dept.value))
                  .map((id) => id.value);
                form.setFieldsValue({
                  subDepartments: selectedSubDept,
                });
              }
            });
          }

        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };


  const fetchWorkspaces = () => {
    const payload = {
      type: "settings",
    };
    ServiceUtils.postRequest("listWorkspaces", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let res = JSON.parse(
            JSON.stringify(response.data?.data?.workspace_list)
          );
          setWorkspaces(res);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchReports = () => {
    let payload = {
      workspaces : form.getFieldValue('workspaces')?.value 
    };

    ServiceUtils.postRequest("listReports", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let reportIds = JSON.parse(JSON.stringify(response?.data?.data));
          setReports(reportIds);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const fetchDepartments = () => {
    ServiceUtils.getRequest("listDepartments").then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let departmentIds = JSON.parse(JSON.stringify(response?.data?.data));
          setDepartments(departmentIds);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const fetchSubDepartments = () => {
    let payload = {
      departments: form.getFieldValue('departments')
    };
    ServiceUtils.postRequest("listSubDepartments", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let subDeptIds = JSON.parse(JSON.stringify(response?.data?.data));
          setSubDepartments(subDeptIds);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const handleInputChange = (key, value, action) => {
    setSubmittable(true);
    if (key === "workspaces") {
      fetchReports();
      form.setFieldsValue({
        reports: []
      });
    } else if (key === "departments") {
        setReRendered(true);
        fetchSubDepartments();
    }
  };

  const handleSave = () => {
    const formValues = form.getFieldsValue(true); 
    const payLoad = {
      reportSettings: {
        workspaces: formValues.workspaces || "",
        reports: formValues.reports || [],
        departments: formValues.departments || [],
        subDepartments: formValues.subDepartments || []
      },
    };
    payLoad['type'] = id ? 'edit' : 'add';
    ServiceUtils.postRequest("saveReports", payLoad).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          alertService.success(response.data.message);
          navigate("/admin/reportSettings");
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const SubmitButton = ({ form, children }) => {
    return (
      <Button
        type="primary"
        htmlType="submit"
        disabled={!submittable}
        onClick={handleSave}
      >
        {children}
      </Button>
    );
  };

  return (
    <div>
        {
          <div>
            <Card
                    style={{ width: "100%", height: "fit-content" }}
                    bodyStyle={{ padding: "10px" }}
                  >
                    <BreadcrumbList active={[{ label: "Add Reports", link: "" }]} />
                  </Card>
            <Content
              style={{
                padding: "24px",
                background: "#fff",
                height: "calc(100vh - 90px)",
              }}
            >
              <Form
                form={form}
                name="validateOnly"
                layout="vertical"
                autoComplete="off"
              >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Worspaces
                    </label>
                    <Form.Item
                      name="workspaces"
                      rules={[
                        {
                          required: true,
                          message: "Worspaces is required.",
                        },
                      ]}
                    >
                      <Select
                        labelInValue
                        showSearch
                        disabled={disabled}
                        onChange={(e) => {
                          handleInputChange("workspaces", e, "onchange");
                          form.setFieldsValue({
                            reports: [],
                          });
                        }}
                        onClear={() => {
                          handleInputChange("workspaces", "", "onchange");
                        }}
                        options={workspaces}
                        allowClear
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Reports
                    </label>
                    <Form.Item
                      name="reports"
                      rules={[
                        {
                          required: true,
                          message: "Reports is required.",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        disabled={disabled}
                        labelInValue
                        onChange={(e) => {
                          handleInputChange("reports", e, "onchange");
                        }}
                        onClear={() => {
                          handleInputChange("reports", [], "onchange");
                        }}
                        options={reports}
                        allowClear
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Departments
                    </label>
                    <Form.Item
                      name="departments"
                      rules={[
                        {
                          required: true,
                          message: "Departments is required.",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        onChange={(e) => {
                          handleInputChange("departments", e, "onchange");
                        }}
                        onClear={() => {
                          handleInputChange("departments", [], "onchange");
                        }}
                        options={departments}
                        allowClear
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Sub Departments
                    </label>
                    <Form.Item
                      name="subDepartments"
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        onChange={(e) => {
                          handleInputChange("subDepartments", e, "onchange");
                        }}
                        onClear={() => {
                          handleInputChange("subDepartments", [], "onchange");
                        }}
                        options={subDepartments}
                        allowClear
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
                 <div
                className="submit-block"  style={{ position: 'absolute',bottom: '5px', right:'5px' }}
              >
                <div style={{ paddingRight: "10px" }}>
                  <SubmitButton form={form} type="primary" htmlType="submit">{id ? "Update" : "Save"}</SubmitButton>
                </div>
                <Button onClick={()=>navigate("/admin/reportSettings")}>Cancel</Button>
              </div>
            </Content>
          </div>
        }
      </div>
  );
};

export default AddEditReports;
